<template>
      <v-col>
        <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="headers"
            :items="tableItems"
            class="elevation-1"
            :loading="hoursByRateLoadStatus===1"
            disable-pagination
            hide-default-footer
            must-sort
            dense
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Godziny wg cennika</v-toolbar-title>
                
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select label="Rok" v-model="selectedYear"  class="choose_year" :items="calendarYears" hide-details ></v-select>
               
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select label="Miesiąc" v-model="selectedMonth"  class="choose_month" :items="lookups.months" hide-details ></v-select>

                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select label="Cennik" v-model="selectedRate"  class="choose_rate" :items="lookups.rates" clearable hide-details ></v-select>
                <v-spacer></v-spacer>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              size="28"
                              class="mr-4"
                              :disabled="tableItems.length==0"
                              @click="downloadXlsFile"
                            >
                              mdi-file-excel
                            </v-icon>
                          </template>
                          <span>Pobierz jako Excel</span>
                        </v-tooltip>

                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              size="28"
                              class="mr-4"
                              :disabled="tableItems.length==0"
                              @click="printFile"
                            >
                              mdi-printer
                            </v-icon>
                          </template>
                          <span>Drukuj</span>
                        </v-tooltip>

              </v-toolbar>
            </template>
            <template v-if="tableItems.length>1" slot="body.append">
                <tr class="v-data-table__selected font-weight-medium subheading">
                        <td></td><td></td><td></td><td></td><td></td>
                        <td>Suma</td>
                        <td>{{ sumField('hours')}}</td>
                        <td></td>
                        <td>{{ sumField('hoursAmount')}}</td>
                </tr>
            </template>
          </v-data-table> 
        </v-card>
      
      </v-col>
      

</template>

<script>
  import Vue from 'vue'
  import XLSX from "xlsx"
  import jsPDF from 'jspdf'
  import logusLogo from '../../plugins/jspdf_resources'
  import 'jspdf-autotable'

  export default {
    data: () => ({
      componentKey:0,
      dialog: false,
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp'},
        { text: 'Nazwisko', value: 'surname'},
        { text: 'Imię', value: 'name'},
        { text: 'Grupa', value: 'courses'},
        { text: 'Numer karty', value: 'document'},
        { text: 'Ważna do', value: 'expiry'},
        { text: 'Godziny', value: 'hours'},
        { text: 'Stawka', value: 'rate.hour'},
        { text: 'Naliczenie', value: 'hoursAmount'},
      ],
      
    }),
    watch: {
     
    },
    computed: {
      calendarYears(){
        var calYears = [];
        this.lookups.years.forEach(year => {
          if(!Vue._.find(calYears,{value:year.year_from}))calYears.push({value:year.year_from,text:year.year_from.toString()});
          if(!Vue._.find(calYears,{value:year.year_to}))calYears.push({value:year.year_to,text:year.year_to.toString()});
        });
        return calYears;
      },
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getHoursByRateOptions;
        },
        set (value) {
          this.$store.dispatch( 'setHoursByRateOptions', {options:value} )
        }
      },
      selectedYear:{
        get () {
          return this.$store.getters.getHoursByRateOptions.selectedYear;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedYear = value;
          this.options = currentOptions;
        }
      },

      selectedMonth:{
        get () {
          return this.$store.getters.getHoursByRateOptions.selectedMonth;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedMonth = value;
          this.options = currentOptions;
        }
      },
      selectedRate:{
        get () {
          return this.$store.getters.getHoursByRateOptions.selectedRate;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedRate = value;
          this.options = currentOptions;
        }
      },
     
      tableItems(){
        return this.$store.getters.getHoursByRate;
      },
      hoursByRateLoadStatus(){
        return this.$store.getters.getHoursByRateLoadStatus;
      },
      
    },
    mounted(){
      if(this.lookups.years.length>0){
        this.loadHoursByRate();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          this.loadHoursByRate();
        }, 2000)
      }
    },
    methods: {
      sumField(key) {
        // sum data in give key (property)
        return this.tableItems.reduce((a, b) => a + ((b && b[key])?b[key]:0 || 0), 0)
      },
      loadHoursByRate(){
        var currentOptions = {...this.$store.getters.getHoursByRateOptions};
        var date = new Date(); 
        //currentOptions.selectedDay = date.toISOString().substr(0,10);
        currentOptions.selectedYear = parseInt(date.toISOString().substr(0,4));
        currentOptions.selectedMonth = parseInt(date.toISOString().substr(6,2));
        this.$store.commit( 'setHoursByRateOptions', currentOptions )
      },
      downloadXlsFile(){
        //przygotowanie danych
        var items = []
        this.tableItems.forEach(item => {
          items.push({surname:item.surname,name:item.name,courses:item.courses,document:item.document, expiry:item.expiry, 
          hours:item.hours, rate:item.rate.hour, hoursAmount:item.hoursAmount})
        });

        var wb = XLSX.utils.book_new()
        var ws_name = "Zestawienie";
        var ws = XLSX.utils.aoa_to_sheet([["Nazwisko","Imię","Grupa","Numer karty","Ważna do","Godziny","Stawka","Naliczenie"]]);
        XLSX.utils.sheet_add_json(ws,items,{header:["surname","name","courses","document","expiry","hours","rate","hoursAmount"], skipHeader:true, origin:1})
        
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
      
        var rightNow = new Date();
        rightNow.setMinutes(rightNow.getMinutes() - rightNow.getTimezoneOffset());
        var filename = 'Zestawienie_' + rightNow.toISOString().replace(/-/g,'').replace(/:/g,'').replace('T','_').slice(0,15) +'.xlsx';
        XLSX.writeFile(wb, filename, {})
      },
      generatePDF(){
        var items = []
        var page = 1;
        var lp = 1;
        this.tableItems.sort((a,b)=>(a.surname>b.surname)?1:(b.surname>a.surname)?-1:0).forEach(item => {
          items.push([lp++,item.surname,item.name,item.courses,item.document,item.expiry,item.hours,item.rate.hour,item.hoursAmount]);
        });

        var doc = new jsPDF({
          //orientation: 'landscape',
          unit: 'mm',
          format: 'a4',
        })
        var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
        var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

        doc.setFont("Roboto-Medium", "bold"); // set font
        doc.setFontSize(14);
        doc.addImage(logusLogo, 'PNG', 5, 5, 22.5, 20);
        doc.text('Zestawienie godzin', pageWidth-5, 12, {align:'right',baseline:'bottom'});
        doc.text(_.find(this.lookups.months,{'value':this.selectedMonth}).text + ' ' + this.selectedYear.toString() + ', ' + _.find(this.lookups.rates,{'value':this.selectedRate}).text, pageWidth-5, 20, {align:'right',baseline:'bottom'});
        doc.setFont("Roboto-Regular", "normal"); // set font
        doc.setFontSize(10);
        doc.autoTable({
          didDrawPage: (data) => {
            //doc.text(page.toString(), 5, pageHeight-5);
            doc.text(page.toString(), 5, pageHeight-5, {align:'center',baseline:'bottom'});
            doc.text(this.user.name + ' ' + this.user.surname + ' / '+ new Date().toLocaleString(), pageWidth-5, pageHeight-5, {align:'right'});
            page++;
          },
          theme:'grid',
          styles:{font:'Roboto-Regular', fontSize:9 },
          headStyles: { fillColor: [210, 210, 210],textColor:20 },
          footStyles: { fillColor: [210, 210, 210],textColor:20 },
          startY: 30,
          showFoot:'lastPage',
          margin: {top:5,bottom:10,left:5,right:5},
          //columnStyles: { 3: {font:'Roboto-Medium', halign: 'right' },4: {font:'Roboto-Medium', halign: 'right' }, 5: {font:'Roboto-Medium', halign: 'right' },6: {font:'Roboto-Medium', halign: 'right' } },
          head: [_.map(this.headers,'text')],
          body: items,
          foot: [
            [
              { content: 'Suma', colSpan: 6, styles: {font:'Roboto-Medium',fontStyle:'bold', halign: 'left' } },
              { content: this.sumField('hours'),styles: {font:'Roboto-Medium',fontStyle:'bold',halign: 'left' }},
              { content: '',styles: {font:'Roboto-Medium',fontStyle:'bold',halign: 'left' }},
              { content: this.sumField('hoursAmount'),styles: {font:'Roboto-Medium',fontStyle:'bold',halign: 'left' }},
            ],
          ],
        })
        
        return doc;
      },
      printFile(){
        var doc = this.generatePDF();
        doc.autoPrint();
        doc.output('dataurlnewwindow');
        doc.close();
      },
    },
  }
</script>


<style scoped>
.choose_year{
      max-width: 100px;
}
.choose_month{
      max-width: 150px;
}
.choose_rate{
      max-width: 200px;
}
</style>